const statusCreditTranslate: Record<string, string> = {
  'STATUS.CREDIT.APPLICATION.SENT': 'Enviada',
  'STATUS.CREDIT.APPLICATION.APPROVED': 'Aprobada',
  'STATUS.CREDIT.APPLICATION.TAKEN': 'Tomada',
  'STATUS.CREDIT.APPLICATION.REJECTED': 'Rechazada',
  'STATUS.CREDIT.APPLICATION.NOT_TAKEN': 'No Tomada',
}

export default statusCreditTranslate
